import { render } from "./NoClassAssigned.vue?vue&type=template&id=233d6f77"
import script from "./NoClassAssigned.vue?vue&type=script&lang=js"
export * from "./NoClassAssigned.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__